import React from 'react';

const BookmarksIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="29"
      height="26"
      viewBox="0 0 29 26"
      fill="none"
    >
      <path
        d="M20.6041 2.5C21.3322 2.49939 22.053 2.64413 22.7244 2.92575C23.3958 3.20736 24.0043 3.62018 24.5141 4.14C25.5645 5.20638 26.1533 6.64316 26.1533 8.14C26.1533 9.63685 25.5645 11.0736 24.5141 12.14L14.1541 22.63L3.79407 12.14C2.74365 11.0736 2.15486 9.63685 2.15486 8.14C2.15486 6.64316 2.74365 5.20638 3.79407 4.14C4.30416 3.62055 4.91265 3.20795 5.58398 2.92629C6.25532 2.64464 6.97605 2.49957 7.70407 2.49957C8.4321 2.49957 9.15283 2.64464 9.82416 2.92629C10.4955 3.20795 11.104 3.62055 11.6141 4.14L14.1541 6.74L16.6841 4.16C17.1923 3.63399 17.8014 3.21586 18.475 2.93064C19.1485 2.64542 19.8726 2.49895 20.6041 2.5ZM20.6041 0.500003C19.6097 0.49916 18.6252 0.696858 17.7082 1.0815C16.7912 1.46615 15.9603 2.03 15.2641 2.74L14.1541 3.86L13.0441 2.74C12.347 2.03129 11.5159 1.46841 10.5991 1.08419C9.68225 0.699974 8.69813 0.502097 7.70407 0.502097C6.71001 0.502097 5.72589 0.699974 4.80908 1.08419C3.89228 1.46841 3.06112 2.03129 2.36407 2.74C0.94595 4.18363 0.151367 6.12636 0.151367 8.15C0.151367 10.1736 0.94595 12.1164 2.36407 13.56L14.1541 25.5L25.9441 13.56C27.3622 12.1164 28.1568 10.1736 28.1568 8.15C28.1568 6.12636 27.3622 4.18363 25.9441 2.74C25.2469 2.03136 24.4157 1.46839 23.499 1.08384C22.5822 0.699291 21.5982 0.500832 20.6041 0.500003Z"
        fill="#FEFEFE"
      />
    </svg>
  );
};

export default BookmarksIcon;